<template>
    <div class="china">
        <NavBar :white="true" />
        <SingaporeContent />
    </div>
</template>

<script>
    import NavBar from "../../components/NavBar";
    import SingaporeContent from "../../components/location/SingaporeContent";
    import Configuration from "../../utils/configuration";

    export default {
        name: 'GlobalSingapore',
        components: {
            NavBar,
            SingaporeContent,
        },
        metaInfo: {
          title: 'シンガポールの日系広告代理店、オンラインマーケティングはオロ',
          meta: [
            {
              property: 'description',
              content: 'シンガポールにおける市場調査・オンラインマーケティング・SNSプロモーション・サイト制作案件については、経験豊富なオロにお任せください。ebay・他日系企業において多数の実績があります。',
              vmid: 'description'
            },
            {
              property: 'og:title',
              content: 'シンガポールの日系広告代理店、オンラインマーケティングはオロ',
              vmid: 'og:title'
            },
            {
              property: 'og:url',
              content: 'https://www.oro.com/global/location/singapore/',
              vmid: 'og:url'
            },
            {
              property: 'og:type',
              content: Configuration.site.meta.og_type,
              vmid: 'og:type'
            },
            {
              property: 'og:site_name',
              content: Configuration.site.meta.og_site_name,
              vmid: 'og:site_name'
            }
          ]
        }

    }
</script>

<style lang="scss">
    .china {
        padding-top: 160px;
    }
</style>
